import type { ModeColor } from "@src/types/factory-dashboard";

const GREY: ModeColor = {
  outline: "rgb(138, 143, 152)",
  background: "rgba(138, 143, 152, 0.1)",
};
const YELLOW: ModeColor = {
  outline: "rgb(225, 199, 67)",
  background: "rgba(225, 199, 67, 0.1)",
};
const GREEN: ModeColor = {
  outline: "rgb(25, 175, 0)",
  background: "rgba(25, 175, 0, 0.1)",
};
const RED: ModeColor = {
  outline: "rgb(253, 56, 56)",
  background: "rgba(253, 56, 56, 0.1)",
};

export const modeMapping = {
  0: { label: "modules.machineOverviewContainer.mode.off", color: GREY },
  1: { label: "modules.machineOverviewContainer.mode.setup", color: YELLOW },
  2: {
    label: "modules.machineOverviewContainer.mode.semiAutomatic",
    color: GREEN,
  },
  3: {
    label: "modules.machineOverviewContainer.mode.automatic",
    color: GREEN,
  },
  8: { label: "modules.machineOverviewContainer.mode.service", color: RED },
};

export const machinesTT = [
  {
    sourceId: "1a3ebb66-1d6f-8d6f-bca4-d1a8b7b63602",
    nodes: {
      opMode: "ns=4;s=APPL.system.sv_OperationMode",
      actCyclesDone: "ns=4;s=APPL.system.sv_iProdCounterAct",
      setCyclesCompleteToDo: "ns=4;s=APPL.system.sv_iProdCounterSet",
      productionDatasetName: "ns=4;s=APPL.system.sv_sMoldData",
    },
    modeMapping,
  },
  {
    sourceId: "ea9d4524-85ce-85ce-bb6b-b85b676a4b02",
    nodes: {
      opMode: "ns=4;s=APPL.system.sv_OperationMode",
      actCyclesDone: "ns=4;s=APPL.system.sv_iProdCounterAct",
      setCyclesCompleteToDo: "ns=4;s=APPL.system.sv_iProdCounterSet",
      productionDatasetName: "ns=4;s=APPL.system.sv_sMoldData",
    },
    modeMapping,
  },
];
